export const ConditionalWrapper = ({ condition, WrapperComponent, children }) => (condition
    ? WrapperComponent({ children })
    : children);
//# sourceMappingURL=ConditionalWrapper.js.map